export default __webpack_public_path__ + "static/media/logo.62c7d69a.jpg";